/* PW Free Wipes: isolated from the legacy offer UI, disabled until server activation. */
(() => {
  if (window.PWFreeWipes) return;
  const PRODUCTS = Object.freeze([
    { name: "Green Tea", variantId: 57265075356026, sku: "WWET003-15", price: 28,
      image: "https://cdn.shopify.com/s/files/1/0803/2459/1905/files/packaging_wise_wet_wipe_green_tea_WWET003-15_1_4149766e-ba85-4d31-9110-3ec13cb9b542.jpg?v=1789382496" },
    { name: "Lavender", variantId: 57265080992122, sku: "WWET001-15", price: 28,
      image: "https://cdn.shopify.com/s/files/1/0803/2459/1905/files/packaging_wise_wet_wipe_lavender_WWET001-15_1.jpg?v=1789382465" },
    { name: "Lemon", variantId: 57265080533370, sku: "WWET002-15", price: 28,
      image: "https://cdn.shopify.com/s/files/1/0803/2459/1905/files/packaging_wise_wet_wipe_lemon_WWET002-15_1.jpg?v=1789382442" },
    { name: "Mandarin", variantId: 57265074766202, sku: "WWET004-15", price: 28,
      image: "https://cdn.shopify.com/s/files/1/0803/2459/1905/files/packaging_wise_wet_wipe_mandarin_WWET004-15_1.jpg?v=1789382515" },
  ]);
  const root = () => document.querySelector("[data-pw-free-wipes]");
  const engine = () => window.PWOfferEngine;
  let overlay = null;
  let selected = null;
  let pending = false;
  let previousFocus = null;
  let dismissal = null;
  const paidAdds = new Set();
  let addPresentation = null;
  let compatibilityPaused = false;
  let cartContext = /\/cart\/?$/.test(location.pathname);
  const storageKey = kind => "pw-free-wipes-v2:" + kind + ":" + customerId();
  const readStored = (kind, session = false) => {
    try { const storage = session ? sessionStorage : localStorage; return JSON.parse(storage.getItem(storageKey(kind)) || "null"); } catch { return null; }
  };
  const writeStored = (kind, value, session = false) => {
    try { const storage = session ? sessionStorage : localStorage; storage.setItem(storageKey(kind), JSON.stringify(value)); } catch { /* Private browsing: retain memory state. */ }
  };
  const isCartContext = () => cartContext || Boolean(document.querySelector(".site-header__cart.is-active"));
  function rememberDismissal() {
    const basket = addPresentation?.cart || cartSnapshot;
    dismissal = { cartToken: basket?.token || "", totals: Object.fromEntries(totalsByEligibleProduct(basket)),
      qualified: [...totalsByEligibleProduct(basket)].filter(([,qty]) => qty >= 3).map(([id]) => id) };
    writeStored("dismissed", dismissal);
  }
  function offerDismissed(cart) {
    dismissal ||= readStored("dismissed");
    if (!dismissal) return false;
    // Dismissal belongs to one Shopify cart, never every future basket.
    // Records from the earlier implementation had no cart identity.
    if (cart?.token && dismissal.cartToken !== cart.token) {
      dismissal = null;
      writeStored("dismissed", null);
      return false;
    }
    const newProductAdded = [...totalsByEligibleProduct(cart)].some(([id,qty]) =>
      !dismissal.qualified.includes(id) && qty >= 3 && qty - Number(dismissal.totals[id] || 0) >= 3);
    if (!newProductAdded) return true;
    dismissal = null;
    writeStored("dismissed", null);
    return false;
  }
  const presentationReady = () => {
    const hint = readStored("ready", true);
    return Boolean(hint && Date.now() - hint.at < 60000);
  };
  const customerId = () => root()?.dataset.pwCustomerId || "";
  const cfg = () => ({
    shop: root()?.dataset.pwShop || "",
    api: String(root()?.dataset.pwApi || "https://packaging-wise-upsell-crosssell.vercel.app").replace(/\/$/, ""),
  });
  const originalFetch = window.fetch.bind(window);
  const nativeFetch = (...args) => (engine()?.nativeFetch || originalFetch)(...args);
  const money = value => "£" + Number(value || 0).toFixed(2);
  const tracked = (eventType, extras = {}) => {
    const { shop, api } = cfg();
    if (!shop) return;
    void fetch(api + "/api/storefront-events", {
      method: "POST", mode: "cors", keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ shop, eventType, source: "pw_free_wipes", placement: "post_add_popup",
        deviceType: window.innerWidth < 768 ? "Mobile" : "Desktop",
        customerState: customerId() ? "Logged in" : "Guest",
        sessionId: sessionStorage.getItem("pw_offer_session_id") || "",
        path: location.pathname, ...extras }),
    }).catch(() => {});
  };
  function tag(tag, cls, text) {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function dismiss(reason) {
    if (!overlay) return;
    const node = overlay;
    overlay = null;
    offerRevision++;
    if (["close", "escape", "no_thanks", "backdrop", "added"].includes(reason)) rememberDismissal();
    node.close?.();
    document.documentElement.classList.remove("pw-offer-lock");
    window.removeEventListener("keydown", onKeyDown);
    node.remove();
    previousFocus?.focus?.();
    if (reason !== "added") tracked("gift_dismiss", { action: reason });
  }
  function onKeyDown(event) {
    if (!overlay) return;
    if (event.key === "Escape") { event.preventDefault(); dismiss("escape"); return; }
    if (event.key !== "Tab") return;
    const focusable = [...overlay.querySelectorAll("button:not(:disabled)")];
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
  function show(checking = false) {
    if (overlay) return false;
    selected = null;
    previousFocus = document.activeElement;
    overlay = tag("dialog", "pw-free-wipes-overlay");
    overlay.addEventListener("cancel", event => { event.preventDefault(); dismiss("escape"); });
    const dialog = tag("section", "pw-free-wipes-dialog");
    dialog.setAttribute("role", "dialog");
    dialog.setAttribute("aria-modal", "true");
    dialog.setAttribute("aria-labelledby", "pw-free-wipes-title");
    const close = tag("button", "pw-free-wipes-close", "×");
    close.type = "button"; close.setAttribute("aria-label", "Close gift offer");
    close.addEventListener("click", () => dismiss("close"));
    const header = tag("header", "pw-free-wipes-header");
    header.appendChild(tag("div", "pw-free-wipes-eyebrow", "✧ YOUR FREE GIFT ✧"));
    const heading = tag("h2", "", checking ? "Choose your FREE gift" : "You've unlocked a ");
    heading.id = "pw-free-wipes-title";
    if (!checking) heading.appendChild(tag("em", "", "FREE gift!"));
    header.appendChild(heading);
    const sub = tag("p", "", "Choose your favourite Wet Wipes — Select one. One pack of 500, completely on us.");
    header.appendChild(sub);
    const grid = tag("div", "pw-free-wipes-grid");
    grid.setAttribute("role", "radiogroup");
    grid.setAttribute("aria-label", "Select one free Wet Wipes scent");
    const options = [];
    const add = tag("button", "pw-free-wipes-add", "Add My Free Pack →");
    add.type = "button";
    add.disabled = true;
    const error = tag("div", "pw-free-wipes-message");
    error.setAttribute("role", "status");
    let availabilityConfirmed = !checking;
    // Read-only verification runs while the shopper chooses a scent.
    // The Add transaction below still waits for a fresh affirmative server result.
    overlay.__pwConfirmAvailability = () => {
      availabilityConfirmed = true;
      heading.textContent = "You've unlocked a FREE gift!";
      error.textContent = "";
      add.disabled = pending || !selected;
    };
    for (const product of PRODUCTS) {
      const card = tag("button", "pw-free-wipes-choice");
      card.type = "button";
      card.dataset.variantId = String(product.variantId);
      card.setAttribute("role", "radio");
      card.setAttribute("aria-checked", "false");
      card.setAttribute("aria-label", product.name + ", " + money(product.price) + ", FREE");
      card.appendChild(tag("span", "pw-free-wipes-radio"));
      const photo = tag("span", "pw-free-wipes-img");
      const img = document.createElement("img");
      img.src = product.image; img.alt = product.name + " Wise Wipes"; img.loading = "eager";
      photo.appendChild(img); card.appendChild(photo);
      card.appendChild(tag("span", "pw-free-wipes-tag", "FREE GIFT"));
      card.appendChild(tag("span", "pw-free-wipes-title", product.name + " Wise Wipes"));
      card.appendChild(tag("span", "pw-free-wipes-pack", "Pack of 500"));
      card.appendChild(tag("span", "pw-free-wipes-sku", product.sku));
      const prices = tag("span", "pw-free-wipes-prices");
      prices.appendChild(tag("del", "pw-free-wipes-old", money(product.price)));
      prices.appendChild(tag("strong", "pw-free-wipes-free", "FREE"));
      card.appendChild(prices);
      const chosen = tag("span", "pw-free-wipes-selected");
      card.appendChild(chosen);
      options.push({ card, chosen, product });
      card.addEventListener("click", () => {
        selected = product;
        for (const option of options) {
          const current = option.product === product;
          option.card.setAttribute("aria-checked", String(current));
          option.chosen.textContent = current ? "✓ Selected" : "";
        }
        add.disabled = pending || !selected;
        if (availabilityConfirmed) error.textContent = "";
        void prepareGiftAdd().catch(() => {});
        tracked("gift_scent_select", { variantId: String(product.variantId), action: product.name });
      });
      grid.appendChild(card);
    }
    const actions = tag("div", "pw-free-wipes-actions");
    actions.append(add, error);
    const noThanks = tag("button", "pw-free-wipes-dismiss", "No thanks");
    noThanks.type = "button";
    noThanks.addEventListener("click", () => dismiss("no_thanks"));
    actions.appendChild(noThanks);
    const warning = tag("p", "pw-free-wipes-warning",
      "IMPORTANT: Claiming this free pack will replace your Buy More Save More savings and cannot be combined with BOGO, bundles, other offers or discount codes. To keep your existing discounts, select No thanks.");
    const note = tag("p", "pw-free-wipes-disclaimer",
      "One free gift per customer, once in a lifetime. Cannot be combined with other offers or discount codes.");
    dialog.append(close, header, grid, warning, actions, note);
    overlay.appendChild(dialog);
    overlay.addEventListener("click", event => {
      if (event.target === overlay) dismiss("backdrop");
    });
    const cartFocus = document.querySelector(".site-header__cart.is-active [data-pw-cart-close]");
    if (cartFocus) { previousFocus = cartFocus; cartFocus.focus({ preventScroll: true }); }
    document.body.appendChild(overlay);
    if (typeof overlay.showModal === "function") overlay.showModal();
    else overlay.setAttribute("open", "");
    document.documentElement.classList.add("pw-offer-lock");
    window.addEventListener("keydown", onKeyDown);
    close.focus();
    tracked("gift_popup_view");
    add.addEventListener("click", async () => {
      if (!selected || pending) return;
      pending = true; add.disabled = true; add.textContent = "Adding your FREE pack…"; error.textContent = "";
      const giftStartedAt = Date.now();
      tracked("gift_add_attempt", { variantId: String(selected.variantId), action: selected.name });
      try {
        const { cart, check } = await prepareGiftAdd();
        root().dataset.pwGiftPreparationMs = String(Date.now() - giftStartedAt);
        if (!qualifyingCart(cart) || !check?.enabled || !check?.eligible) throw new Error("This gift is no longer available for this cart.");
        const result = await nativeFetch("/cart/add.js", {
          method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ sections: ["cart-ajax"], items: [{ id: selected.variantId, quantity: 1,
            properties: { "_pw_free_wipes_gift": "true", "_pw_free_wipes_scent": selected.name, "_pw_cart_recommendation": "pw_free_wipes_gift" } }] }),
        });
        if (!result.ok) throw new Error("Could not add your free pack.");
        const receipt = await result.json().catch(() => null);
        // A successful cart/add response is NOT proof of a free pack.
        // Verify the cart line was actually discounted to zero, otherwise
        // remove exactly the line we just created and fail closed.
        const addedCart = await currentCart();
        const giftLines = (addedCart.items || []).filter(item =>
          item.properties?._pw_free_wipes_gift === "true" &&
          String(item.variant_id) === String(selected.variantId));
        const validFreeGift = giftLines.length === 1 &&
          Number(giftLines[0].quantity) === 1 &&
          Number(giftLines[0].final_line_price) === 0;
        if (!validFreeGift) {
          const toRemove = giftLines[0]?.key;
          if (toRemove) {
            await nativeFetch("/cart/change.js", {
              method: "POST", credentials: "same-origin",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: toRemove, quantity: 0 }),
            });
          }
          throw new Error("The free gift discount could not be verified. No charged gift was kept in your cart.");
        }
        root().dataset.pwGiftAddMs = String(Date.now() - giftStartedAt);
        receiveCart(addedCart, "read");
        void eligibility(addedCart).catch(() => {});
        tracked("gift_add_success", { variantId: String(selected.variantId), action: selected.name });
        // The discount is computed and verified by Shopify Functions at checkout.
        dismiss("added");
        if (/\/cart\/?$/.test(location.pathname)) {
          document.dispatchEvent(new CustomEvent("cart:build", {
            detail: { source: "pw_free_wipes", cart: addedCart, sections: receipt?.sections }
          }));
          document.dispatchEvent(new CustomEvent("pw:cart:state", { detail: { cart: addedCart, source: "pw_free_wipes" } }));
          return;
        }
        // One refresh is sufficient; multiple aliases caused parallel duplicate
        // drawer rebuilds and competed for mobile bandwidth after every gift.
        document.dispatchEvent(new CustomEvent("cart:refresh", {
          detail: { source: "pw_free_wipes", cart: addedCart, sections: receipt?.sections }
        }));
      } catch (e) {
        error.textContent = e?.message || "Could not add your free pack. Please try again.";
        tracked("gift_add_error", { action: String(e?.message || "unknown").slice(0,100) });
      } finally {
        pending = false; if (overlay) { add.disabled = !selected; add.textContent = "Add My Free Pack →"; }
      }
    });
    return true;
  }
  async function currentCart() {
    const response = await nativeFetch("/cart.js", { credentials: "same-origin", cache: "no-store" });
    if (!response.ok) throw new Error("Unable to read cart");
    return response.json();
  }
  // Prepare on scent selection while the customer is deciding. Only a recent
  // server-verified result for this exact confirmed cart may skip pre-add reads.
  // This is deliberately separate from the presentation-only session hint.
  let giftPreparation = null;
  async function prepareGiftAdd() {
    const key = cartSnapshot ? cartKey(cartSnapshot) : null;
    const cached = giftPreparation;
    if (!paidAdds.size && cached && cached.key === key && Date.now() - cached.at < 5000)
      return cached.promise;
    const preparation = { key, at: Date.now(), promise: null };
    preparation.promise = (async () => {
      const additions = await Promise.all([...paidAdds].map(add => add.wait));
      if (additions.some(ok => !ok)) throw new Error("Your item could not be added. Please try again.");
      const cart = await currentCart();
      preparation.key = cartKey(cart);
      // A short exact-cart authorization window covers time spent choosing.
      // Shopify's discount Function and the post-add £0 check remain authoritative;
      // checkout still performs an uncached customer eligibility request.
      const check = await eligibility(cart, 30000);
      return { cart, check };
    })();
    giftPreparation = preparation;
    try { return await preparation.promise; }
    catch (error) { if (giftPreparation === preparation) giftPreparation = null; throw error; }
  }
  const eligibilityRequests = new Map();
  const eligibilityCache = new Map();
  const cartKey = cart => JSON.stringify((cart?.items || []).map(item => [
    String(item.variant_id || ""), Number(item.quantity || 0),
    item.properties?._pw_free_wipes_gift === "true",
  ]).sort((a,b) => JSON.stringify(a).localeCompare(JSON.stringify(b))));
  // The API ignores gift lines; cache only the exact paid cart and customer.
  function eligibilityCartKey(cart) {
    return cartKey({ items: (cart?.items || []).filter(item => item.properties?._pw_free_wipes_gift !== "true") });
  }
  async function eligibility(cart, maxAge = 0) {
    const { shop, api } = cfg();
    if (!shop || !customerId()) return null;
    const key = customerId() + ":" + eligibilityCartKey(cart);
    const cached = eligibilityCache.get(key);
    if (maxAge && cached && Date.now() - cached.at < maxAge) return cached.value;
    if (eligibilityRequests.has(key)) return eligibilityRequests.get(key);
    const request = (async () => {
      const items = (cart?.items || []).slice(0,100).map(item => ({
        variantId: String(item.variant_id || ""),
        quantity: Math.max(0, Number(item.quantity || 0)),
        gift: item.properties?._pw_free_wipes_gift === "true",
      }));
      const response = await fetch(api + "/api/free-wipes", {
        method: "POST", mode: "cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ shop, customerId: customerId(), items }),
      });
      if (!response.ok) return null;
      const value = await response.json();
      if (eligibilityCache.size >= 12) eligibilityCache.delete(eligibilityCache.keys().next().value);
      eligibilityCache.set(key, { at: Date.now(), value });
      if (value?.enabled && value?.eligible) writeStored("ready", { at: Date.now() }, true);
      return value;
    })();
    eligibilityRequests.set(key, request);
    try { return await request; }
    finally { if (eligibilityRequests.get(key) === request) eligibilityRequests.delete(key); }
  }
  async function maybeShow(cart) {
    if (overlay) return true;
    if (!isAllowedTheme() || !signedInCustomer() || pending) return false;
    receiveCart(cart, "engine", true);
    return Boolean(overlay);
  }
  // Only touch cart lines that this campaign itself marked. If a shopper
  // changes cart quantities or loses eligibility, remove the promotional line
  // instead of leaving a surprise full-price £28 product at checkout.
  let reconcileTimer = 0;
  let reconciliationPending = false;
  async function reconcile() {
    if (!root() || reconciliationPending) return;
    reconciliationPending = true;
    try {
      const cart = await currentCart();
      const marked = (cart.items || []).filter(item =>
        item.properties?._pw_free_wipes_gift === "true" &&
        PRODUCTS.some(p => String(p.variantId) === String(item.variant_id)));
      if (!marked.length) return;
      const check = await eligibility(cart);
      // Missing auth, campaign disabled, or changed qualifying quantity:
      // never keep a visibly gifted line whose 100% discount may not apply.
      const valid = Boolean(qualifyingCart(cart) && check?.enabled && check?.eligible &&
        marked.length === 1 && Number(marked[0].quantity) === 1 &&
        Number(marked[0].final_line_price) === 0);
      if (valid) return;
      for (const item of marked) {
        await nativeFetch("/cart/change.js", {
          method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        });
      }
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      const refreshed = await currentCart();
      for (const item of marked) {
        document.querySelectorAll(".cart__item[data-key]").forEach(line => {
          if (line.dataset.key === item.key) line.remove();
        });
      }
      for (const name of ["cart:refresh", "cart:updated"]) {
        document.dispatchEvent(new CustomEvent(name, { detail: { source: "pw_free_wipes_reconcile", cart: refreshed } }));
      }
    } catch (error) {
      console.warn("[PW Free Wipes] Could not reconcile gift cart line", error);
    } finally { reconciliationPending = false; }
  }
  function scheduleReconcile(event) {
    if (event?.detail?.source === "pw_free_wipes_reconcile") return;
    if (cartSnapshot && !hasGift(cartSnapshot)) return;
    clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(reconcile, 180);
  }
  for (const event of ["cart:change", "cart:updated", "cart:refresh"]) {
    document.addEventListener(event, scheduleReconcile);
  }
  // Do not show on page load or opening/refreshing cart.
  // A successful Shopify cart mutation is required. Changes via the drawer
  // (cart/change.js or cart/update.js) count just like direct cart/add.js.
  const ALLOWED_THEME_IDS = new Set(["187143979386","187165737338","187167146362","187183923578","187296350586","187318403450","187322073466"]);
  // UI product prefilter mirrors the active Shopify PW Free Wet Wipes Gift whitelist (26 products).
  // Backend /api/free-wipes remains authoritative for customer, quantities and redemption.
  const TR_CN_ELIGIBLE_IDS = new Set(["15124538524026","15124539146618","15124548190586","15124548321658","15124562903418","15124563296634","15124662681978","15124665991546","15124666712442","15667304300922","15762387370362","15762389533050","15762496815482","15762509529466","15762511200634","15762522931578","16001179287930","16050793087354","16124372582778","16124373303674","16138510729594","16144839115130","16190620336506","16190620434810","16190620467578","16190620500346"]);
  const isAllowedTheme = () => {
    const shopTheme = window.Shopify?.theme;
    const themeId = String(root()?.dataset.pwThemeId || shopTheme?.id || "");
    return Boolean(root()) && ALLOWED_THEME_IDS.has(themeId);
  };
  const totalsByEligibleProduct = cart => {
    const map = new Map();
    for (const item of cart?.items || []) {
      const productId = String(item.product_id || "");
      if (!TR_CN_ELIGIBLE_IDS.has(productId) ||
          item.properties?._pw_free_wipes_gift === "true") continue;
      map.set(productId, (map.get(productId) || 0) + Math.max(0, Number(item.quantity) || 0));
    }
    return map;
  };
  let cartSnapshot = null;
  let cartReadInFlight = null;
  let snapshotRevision = 0;
  let offerRevision = 0;
  const signedInCustomer = () => Boolean(customerId());
  const hasGift = cart => (cart?.items || []).some(item => item.properties?._pw_free_wipes_gift === "true");
  const qualifyingCart = cart => [...totalsByEligibleProduct(cart).values()].some(qty => qty >= 3);
  function warmAvailability(cart) {
    // Preflight must use a genuinely qualifying paid basket, never a fabricated 3-item projection.
    if (!isAllowedTheme() || !signedInCustomer() || hasGift(cart) ||
        presentationReady() || !qualifyingCart(cart)) return;
    void eligibility(cart, 15000).catch(() => {});
  }
  function receiveCart(next, source = "render", forceOffer = false) {
    if (!next?.items || !isAllowedTheme()) return;
    const previous = cartSnapshot;
    const changed = !previous || cartKey(previous) !== cartKey(next);
    cartSnapshot = next;
    snapshotRevision++;
    syncGiftSummary(next);
    if (!signedInCustomer()) return;
    if (!paidAdds.size && !(next.items || []).some(item => Number(item.quantity) > 0)) {
      dismissal = null;
      writeStored("dismissed", null);
    }
    // Old cart reads while Shopify is still adding must not cancel the choices.
    if (overlay?.dataset.pwCartPending === "true" && addPresentation) {
      const includesAddedItems = (addPresentation.cart.items || []).every(expected =>
        (next.items || []).filter(item => String(item.variant_id) === String(expected.variant_id))
          .reduce((sum, item) => sum + Number(item.quantity || 0), 0) >= Number(expected.quantity || 0));
      if (paidAdds.size || (source !== "read" && !includesAddedItems)) return;
    }
    if (hasGift(next) || !qualifyingCart(next)) {
      offerRevision++;
      if (overlay && !pending) dismiss("cart_no_longer_eligible");
      warmAvailability(next);
      return;
    }
    if (overlay?.dataset.pwCartPending === "true" && !paidAdds.size && qualifyingCart(next)) {
      overlay.dataset.pwCartPending = "false";
      addPresentation = null;
      const currentOverlay = overlay;
      void eligibility(next, 5000).then(check => {
        if (overlay !== currentOverlay) return;
        if (check?.enabled && check?.eligible) overlay.__pwConfirmAvailability?.();
        else dismiss("unavailable");
      }).catch(() => { if (overlay === currentOverlay) dismiss("verification_failed"); });
      return;
    }
    // Background renders and page navigation must never interrupt browsing.
    if (!isCartContext() || offerDismissed(next) || overlay || pending || (!changed && !forceOffer)) {
      warmAvailability(next);
      return;
    }
    // Other observers can emit optimistic cart objects before Shopify confirms the add.
    // Verify the real cart before displaying anything, including a loading dialog.
    if (source !== "read" && source !== "cart_page") {
      void readConfirmedCart(true);
      return;
    }
    const revision = ++offerRevision;
    const renderAt = Date.now();
    const ready = presentationReady();
    show(!ready);
    if (overlay) overlay.dataset.pwCartToPopupMs = String(Date.now() - renderAt); // Immediate checking UI, never an unverified Add button.
    // Even with a fast presentation hint, warm real authorization in the background.
    void eligibility(next, 15000).then(check => {
      if (revision !== offerRevision || !overlay || hasGift(cartSnapshot) ||
          !qualifyingCart(cartSnapshot)) return;
      if (check?.enabled === true && check?.eligible === true) {
        overlay.__pwConfirmAvailability?.();
      } else {
        dismiss("unavailable");
      }
    }).catch(error => {
      if (revision === offerRevision && overlay) dismiss("verification_failed");
      console.warn("[PW Free Wipes] Offer verification failed", error);
    });
  }
  function readConfirmedCart(forceOffer = false) {
    if (cartReadInFlight) {
      if (forceOffer) cartReadInFlight.then(() => receiveCart(cartSnapshot, "cart_open", true));
      return cartReadInFlight;
    }
    const revision = snapshotRevision;
    cartReadInFlight = currentCart().then(next => {
      // A later confirmed render is newer than this read's initial request.
      if (revision === snapshotRevision) receiveCart(next, "read", forceOffer);
    }).catch(error => console.warn("[PW Free Wipes] Cart read failed", error))
      .finally(() => { cartReadInFlight = null; });
    return cartReadInFlight;
  }
  const initialSnapshot = currentCart().then(cart => {
    if (isAllowedTheme() && signedInCustomer() && window.Image) {
      for (const product of PRODUCTS) { const image = new window.Image(); image.src = product.image; }
    }
    if (!cartSnapshot) {
      cartSnapshot = cart;
      snapshotRevision++;
      syncGiftSummary(cart);
      warmAvailability(cart);
      if (cartContext) receiveCart(cart, "cart_page", true);
    }
    return cart;
  }).catch(() => null);
  function afterSuccessfulCartMutation(event) {
    if (!isAllowedTheme()) return;
    const confirmed = event?.detail?.cart;
    if (confirmed?.items) receiveCart(confirmed, "render");
    else {
      void readConfirmedCart();
    }
  }
  function offerOnCartOpen() {
    cartContext = true;
    if (!isAllowedTheme() || !signedInCustomer() || pending) return;
    if (cartSnapshot) receiveCart(cartSnapshot, "cart_open", true);
    void readConfirmedCart(true);
  }
  function mutationKind(url, method) {
    if (String(method || "GET").toUpperCase() !== "POST") return "";
    try {
      const target = new URL(String(url), location.origin);
      if (target.origin !== location.origin) return "";
      const match = target.pathname.match(/\/cart\/(add|change|update)(?:\.js)?\/?$/);
      return match?.[1] || "";
    } catch { return ""; }
  }
  function requestedPaidItems(body) {
    try {
      if (body && typeof body.get === "function") {
        if (body.get("properties[_pw_free_wipes_gift]") === "true") return [];
        return [{ id: String(body.get("id") || ""), quantity: Number(body.get("quantity") || 1) }];
      }
      const payload = typeof body === "string" ? JSON.parse(body) : body;
      return (Array.isArray(payload?.items) ? payload.items : [payload]).filter(item =>
        item?.id && item.properties?._pw_free_wipes_gift !== "true").map(item =>
          ({ id: String(item.id), quantity: Number(item.quantity || 1) }));
    } catch { return []; }
  }
  function productForVariant(id, basket) {
    const known = (basket?.items || []).find(item => String(item.variant_id) === id);
    if (known) return String(known.product_id);
    // Shopify-rendered variant/product associations, never an inferred product title.
    for (const card of document.querySelectorAll("at-add-to-cart[data-variant-id]")) {
      if (String(card.dataset.variantId) === id) return card.closest("[data-product-id]")?.dataset.productId || "";
    }
    for (const form of document.querySelectorAll('form[action*="/cart/add"]')) {
      if (String(form.querySelector('[name="id"]')?.value) !== id) continue;
      return form.closest("[data-product-id]")?.dataset.productId || document.body?.dataset?.pwPageProductId || "";
    }
    return "";
  }
  // Gift offers only open after a fresh, server-confirmed Shopify cart read.
  // Do not render speculative popups from uncommitted cart/add quantities.
  function beginPaidAdd(body) {
    const requested = requestedPaidItems(body).filter(item => /^\d+$/.test(item.id) &&
      Number.isSafeInteger(item.quantity) && item.quantity > 0);
    if (!requested.length) return null;
    const basket = cartSnapshot || window.__PW_CART_DATA__?.value || { items: [] };
    const projected = { ...basket, items: (basket.items || []).map(item => ({ ...item })) };
    for (const item of requested) {
      const productId = productForVariant(item.id, basket);
      if (!productId) continue;
      const previous = projected.items.find(line => String(line.variant_id) === item.id &&
        line.properties?._pw_free_wipes_gift !== "true");
      if (previous) previous.quantity = Number(previous.quantity) + item.quantity;
      else projected.items.push({ variant_id: item.id, product_id: productId,
        quantity: item.quantity, properties: {} });
    }
    const clickAt = Number(root()?.dataset.pwAddClickAt || 0);
    const fromClick = clickAt > 0 && Date.now() - clickAt < 2000;
    const add = { cart: projected, startedAt: fromClick ? clickAt : Date.now(),
      timingSource: fromClick ? "click" : "request", wait: null, status: "pending" };
    paidAdds.add(add);
    return add;
  }
  function finishPaidAdd(add, ok) {
    if (!add) return;
    add.status = ok ? "added" : "failed";
    paidAdds.delete(add);
    if (addPresentation === add) {
      if (!ok) {
        if (overlay) dismiss("add_failed");
        addPresentation = null;
      }
    }
    compatibilityPaused = false;
  }
  function pauseForCompatibility() {
    compatibilityPaused = true;
    if (addPresentation && overlay) dismiss("compatibility");
  }
  function resumeAfterCompatibility() {
    compatibilityPaused = false;
  }
  function observeConfirmedCartMutations() {
    if (window.__pwFreeWipesMutationObserverInstalled) return;
    window.__pwFreeWipesMutationObserverInstalled = true;
    const previousFetch = window.fetch;
    if (typeof previousFetch === "function") {
      window.fetch = function pwGiftCartObservedFetch(input, init) {
        const url = typeof input === "string" ? input : input?.url;
        const method = init?.method || input?.method || "GET";
        const kind = mutationKind(url, method);
        const add = kind === "add" ? beginPaidAdd(init?.body) : null;
        let promise;
        try { promise = previousFetch.apply(this, arguments); }
        catch (error) { finishPaidAdd(add, false); throw error; }
        if (add) add.wait = Promise.resolve(promise).then(response => {
          const ok = response?.ok === true;
          finishPaidAdd(add, ok);
          return ok;
        }, () => { finishPaidAdd(add, false); return false; });
        if (kind) {
          Promise.resolve(promise).then(response => {
            if (response?.ok) afterSuccessfulCartMutation();
          }).catch(() => {});
        }
        return promise;
      };
    }
    const NativeXHR = window.XMLHttpRequest;
    if (NativeXHR?.prototype) {
      const proto = NativeXHR.prototype;
      const nativeOpen = proto.open;
      const nativeSend = proto.send;
      proto.open = function pwGiftCartObservedOpen(method, url, ...rest) {
        this.__pwFreeWipesMutation = mutationKind(url, method);
        return nativeOpen.call(this, method, url, ...rest);
      };
      proto.send = function pwGiftCartObservedSend(body) {
        if (this.__pwFreeWipesMutation) {
          this.addEventListener("load", () => {
            if (this.status >= 200 && this.status < 300) afterSuccessfulCartMutation();
          }, { once: true });
        }
        return nativeSend.call(this, body);
      };
    }
  }
  window.addEventListener("pageshow", scheduleReconcile);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") scheduleReconcile();
  });

  function verifiedGiftIn(cart) {
    const lines = (cart?.items || []).filter(item => item.properties?._pw_free_wipes_gift === "true");
    return lines.length === 1 && Number(lines[0].quantity) === 1 &&
      Number(lines[0].final_line_price) === 0 &&
      PRODUCTS.some(p => String(p.variantId) === String(lines[0].variant_id));
  }
  // The rewards summary previously counted the gift's retail value toward
  // estimated free shipping. Use the amount actually payable for this gift cart.
  function syncGiftSummary(cart) {
    if (!isAllowedTheme() || !verifiedGiftIn(cart)) return;
    const subtotal = Math.max(0, Number(cart.total_price || 0));
    const shipping = subtotal >= 10000 ? 0 : 899;
    const vat = Math.round((subtotal + shipping) * .2);
    for (const summary of document.querySelectorAll("[data-wise-cart-summary]")) {
      const vatNode = summary.querySelector(".pww-summary__vat strong");
      const totalNode = summary.querySelector(".pww-summary__grand strong:last-child");
      if (vatNode) vatNode.textContent = money(vat / 100);
      if (totalNode) totalNode.textContent = money((subtotal + shipping + vat) / 100);
      const shippingRows = [...summary.querySelectorAll(".pww-summary__shipping")];
      let row = shippingRows.shift();
      for (const duplicate of shippingRows) duplicate.remove();
      if (!shipping) { row?.remove(); continue; }
      if (!row) {
        row = tag("div", "pww-summary__shipping");
        row.setAttribute("data-pw-gift-shipping", "");
        row.append(tag("span", "", "Shipping (UK Express est.)"), tag("strong", "", ""));
        summary.querySelector(".pww-summary__grand")?.before(row);
      }
      row.querySelector("strong").textContent = money(shipping / 100);
    }
  }
  let giftCheckoutPending = false;
  async function giftCheckout(event) {
    const trigger = event.type === "submit" ? event.submitter :
      event.target?.closest?.('button[name="checkout"],input[name="checkout"],button.cart__checkout,a[href$="/checkout"]');
    if (!trigger || !isAllowedTheme() || !verifiedGiftIn(cartSnapshot)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (giftCheckoutPending) return;
    giftCheckoutPending = true;
    try {
      const snapshotKey = eligibilityCartKey(cartSnapshot);
      const preflight = eligibility(cartSnapshot, 5000).catch(() => null);
      const fresh = await currentCart();
      const check = eligibilityCartKey(fresh) === snapshotKey ? await preflight : await eligibility(fresh, 5000);
      if (!verifiedGiftIn(fresh) || !qualifyingCart(fresh) || !check?.enabled || !check?.eligible) {
        await reconcile();
        throw new Error("Your free gift needs verification. Please review your basket and try again.");
      }
      // Only an already-selected, server-verified exclusive Wet Wipes gift
      // skips the competing BOGO picker; all other checkouts retain their flow.
      location.assign((window.Shopify?.routes?.root || "/") + "checkout");
    } catch (error) {
      console.warn("[PW Free Wipes] Checkout verification failed", error);
      const host = document.querySelector("#CartPageForm, header-cart-drawer .cart__footer");
      if (host) {
        let notice = host.querySelector("[data-pw-gift-checkout-notice]");
        if (!notice) { notice = tag("p", "pw-free-wipes-error"); notice.setAttribute("data-pw-gift-checkout-notice", ""); notice.setAttribute("role", "alert"); host.append(notice); }
        notice.textContent = "Your free gift could not be verified. Please review your basket and try again.";
      }
    } finally { giftCheckoutPending = false; }
  }

  window.PWFreeWipes = { maybeShow, reconcile, pauseForCompatibility, resumeAfterCompatibility };
  if (isAllowedTheme()) {
    // Measure the whole customer interaction, not only time after a cart render.
    window.addEventListener("click", event => {
      if (event.target?.closest?.('button[name="add"],at-add-to-cart .js-add-to-cart,button.quick-add-btn'))
        root().dataset.pwAddClickAt = String(Date.now());
    }, true);
    observeConfirmedCartMutations();
    // Theme render events also cover requests issued through captured fetch references.
    // A fresh authoritative snapshot must show an actual eligible quantity increase.
    document.addEventListener("pw:cart:rendered", afterSuccessfulCartMutation);
    document.addEventListener("ajaxProduct:added", afterSuccessfulCartMutation);
    document.addEventListener("cart:open", offerOnCartOpen);
    document.addEventListener("cart:close", () => {
      cartContext = /\/cart\/?$/.test(location.pathname);
      offerRevision++;
      if (overlay && !pending) dismiss("cart_closed");
    });
    document.addEventListener("product-form:cart:update", afterSuccessfulCartMutation);
    document.addEventListener("cart:updated", afterSuccessfulCartMutation);
    window.addEventListener("click", giftCheckout, true);
    window.addEventListener("submit", giftCheckout, true);
  }
})();




